import React from "react";

import { Box, Chip, Paper, Typography } from "@mui/material";

import { CallHistoryEntry } from "../../../helpers/grpc-call-history";
import { CallHistoryPanel } from "./call-history-panel";

interface HistorySidePanelProps {
  entries: CallHistoryEntry[];
  onReplay: (entry: CallHistoryEntry) => void;
  onClear: () => void;
  onTogglePin: (id: string) => void;
  canReplay: (entry: CallHistoryEntry) => boolean;
}

const PANEL_WIDTH = 300;

export const HistorySidePanel: React.FC<HistorySidePanelProps> = ({
  entries,
  onReplay,
  onClear,
  onTogglePin,
  canReplay,
}) => (
  <Paper
    variant="outlined"
    sx={{
      width: PANEL_WIDTH,
      flexShrink: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 1,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="subtitle2">History</Typography>
      {entries.length > 0 && <Chip label={entries.length} size="small" />}
    </Box>
    <Box sx={{ p: 1, overflow: "auto", flexGrow: 1 }}>
      <CallHistoryPanel
        entries={entries}
        onReplay={onReplay}
        onClear={onClear}
        onTogglePin={onTogglePin}
        canReplay={canReplay}
      />
    </Box>
  </Paper>
);
